import BaseMapper from '../../BaseMapper';

const SportEventMapper = (data, context) => {
    return data;
};

export default SportEventMapper;
